// src/tokens/boxShadow.ts
var boxShadowSmall = "0 2px 8px 0 rgba(0, 0, 0, 0.08)";
var boxShadowMedium = "0 2px 16px 0 rgba(0, 0, 0, 0.08)";
var boxShadowLarge = "0 2px 28px 0 rgba(0, 0, 0, 0.12)";
export { boxShadowSmall, boxShadowMedium, boxShadowLarge };